import React from 'react'

import IICT from '../../image/IICT-Building.jpg'
import Academic from '../../image/Academic.jpg'
import school from '../../image/school.png'
import university from '../../image/university.png'
           
import { VerticalTimeline, VerticalTimelineElement}  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

import './cardabout.css'
import leaf from '../../image/back/leaf.png'   


const Aboutcard2 = () => {
	return (
<div>

<p class="heading-num">02 </p>
<h1 class="heading heading--top">EDUCATION</h1>

  <div>

<VerticalTimeline>

  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    

    contentStyle={{fontFamily:'Comic Sans MS',background:'#0ff0', border: '#0ff0' , borderBottom:'5px solid green' }}  
    contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
    
  icon={<img style={{transform:'translate(5px)'}} src={university} alt={""}/>}
  date={<div>
    <h5>2017 - 2022</h5>
        <div className='row' >
     <div className="col-md-6" style={{marginTop:'20px',filter: 'drop-shadow(2px 4px 6px black)'}}>
      <img alt={""} src={IICT} width={200} height={600} className="img-fluid wow zoomIn" /> 
    </div>
    <div className="col-md-6" style={{marginTop:'20px',filter: 'drop-shadow(2px 4px 6px black)'}}>
        <img alt={""} src={Academic}  width={200} height={600} className="img-fluid wow zoomIn" />
    </div> 
  </div>

</div>}
    iconStyle={{ background: '#f2fcfe', color: '#fff', fontSize: '35px' }}
     
  >
    <h4 className="vertical-timeline-element-title">Bachelor of Science Chemical Engineering and Polymer Science</h4>
    <h6 className="vertical-timeline-element-subtitle" style={{marginTop:'5px'}}><a href="https://www.sust.edu/d/cep" >Shahjalal University Of Science And Technology Sylhet, Bangladesh</a></h6>
    <p style={{fontSize:'20px'}}  >   
    In the growing chemical and polymer industries in Bangladesh and  in order to meet the national and international requirements of the 4 year graduation program Chemical engineering and polymer science at Shahjalal University of Science and Technology Bangladesh .              
    </p>
    <img src={leaf} class='leaf' alt={""}></img>
 
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    date={ <h5>2014 - 2016</h5>}

    icon={<img style={{transform:'translate(5px)'}} src={school} alt={""}/>}
contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
    contentStyle={{fontFamily:'Comic Sans MS',background:'#0ff0', border: '#0ff0' , borderBottom:'5px solid green' }}  
      iconStyle={{ background: '#f2fcfe', color: '#fff', fontSize: '35px' }}
     
  >
    <h4 className="vertical-timeline-element-title">Higher Secondary school Certificate (HSC)</h4>
    <h6 className="vertical-timeline-element-subtitle"> <a href="http://www.bgpscsylhet.edu.bd/"><h5 className="card-title">Border guard public school and college,sylhet,bangladesh</h5></a> </h6>
    
  <p className="card-text"><span style={{fontWeight: 'bold'}}> GPA 4.58 /5.00</span></p>    
             

           
      
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--work"
     date={ <h5>2008 - 2014</h5>}
    contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
    icon={<img style={{transform:'translate(5px)'}} src={school} alt={""}/>}
     iconStyle={{ background: '#f2fcfe', color: '#fff', fontSize: '35px' }}
     contentStyle={{fontFamily:'Comic Sans MS',background:'#0ff0', border: '#0ff0' , borderBottom:'5px solid green' }}  
   
  
  >
    <h4 className="vertical-timeline-element-title"> Secondary School Certificate (SSC)</h4>
    <h6 className="vertical-timeline-element-subtitle"> <a href="https://www.sohopathi.com/shahjalal-university-schoolsylhet/"><h5 className="card-title">shajalal university school and college.sylhet bangladesh</h5></a> </h6>
    <p>
      <span style={{fontWeight: 'bold'}}>GPA 5.00 /5.00</span>
    </p>
  </VerticalTimelineElement>

 

</VerticalTimeline>
   
    </div>

</div>   
	)
}

export default Aboutcard2